export { type WordSubtlex, wordSubtlexTable } from "#word-subtlex-table";
